const contacts = {
  en: {
    translation: {
      title: "Your info",
      // FIELD
      first_name: "First name",
      last_name: "Last name",
      //card: "Card number",
      email: "Email",
      phone: "Phone",
      // BUTTON
      back_menu: "Back to ticket shop",
      continue: "Continue",
      // ERROR
      error_firstName: "Insert your First name",
      error_lastName: "Insert your Last name",
      error_email: "Email is not correct",
    },
  },
  it: {
    translation: {
      title: "I tuoi dati",
      // FIELD
      first_name: "Nome",
      last_name: "Cognome",
      //card: "Numero tessera",
      email: "Email",
      phone: "Telefono",
      // BUTTON
      back_menu: "Torna alla biglietteria",
      continue: "Continua",
      // ERROR
      error_firstName: "Inserisci il tuo nome",
      error_lastName: "Inserisci il tuo cognome",
      error_email: "L' email inserita non è valida",
    },
  },
};

export default contacts;
